export default __webpack_public_path__ + "static/magnifier@2x-9da27e8d26f5d6c054e479c7ad4cdf22.png";